function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M8.00013 0C4.82844 0 2.08795 1.84578 0.793945 4.52175H15.2063C13.9123 1.84578 11.1718 0 8.00013 0Z",
  fill: "#FF9811"
}), React.createElement("path", {
  d: "M8.00013 16C11.1718 16 13.9123 14.1542 15.2063 11.4783H0.793945C2.08795 14.1542 4.82844 16 8.00013 16Z",
  fill: "#6DA544"
}), React.createElement("path", {
  d: "M7.99988 10.7826C9.53666 10.7826 10.7825 9.53679 10.7825 8C10.7825 6.46322 9.53666 5.21741 7.99988 5.21741C6.46309 5.21741 5.21729 6.46322 5.21729 8C5.21729 9.53679 6.46309 10.7826 7.99988 10.7826Z",
  fill: "#0052B4"
}), React.createElement("path", {
  d: "M7.99986 9.7391C8.96035 9.7391 9.73898 8.96047 9.73898 7.99998C9.73898 7.03949 8.96035 6.26086 7.99986 6.26086C7.03937 6.26086 6.26074 7.03949 6.26074 7.99998C6.26074 8.96047 7.03937 9.7391 7.99986 9.7391Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M8.00014 5.85388L8.53667 7.07069L9.85868 6.92691L9.07318 7.99994L9.85868 9.07296L8.53667 8.92918L8.00014 10.146L7.46361 8.92918L6.1416 9.07293L6.9271 7.99994L6.1416 6.92691L7.46361 7.07069L8.00014 5.85388Z",
  fill: "#0052B4"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgIndia = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIndia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/india.ffd16484.svg";
export { ForwardRef as ReactComponent };